import type { ComponentProps, HTMLAttributes } from "react"
import * as ContextMenuPrimitive from "@radix-ui/react-context-menu"
import './menu.scss'

const ContextMenu = ContextMenuPrimitive.Root

const ContextMenuTrigger = ContextMenuPrimitive.Trigger

function ContextMenuContent({ className, ...props }: ComponentProps<typeof ContextMenuPrimitive.Content>) {
  return (
    <ContextMenuPrimitive.Portal>
      <ContextMenuPrimitive.Content
        className={`context-menu-content ${className || ''}`}
        {...props}
      />
    </ContextMenuPrimitive.Portal>
  )
}

function ContextMenuItem({ className, ...props }: ComponentProps<typeof ContextMenuPrimitive.Item>) {
  return (
    <ContextMenuPrimitive.Item
      className={`context-menu-content__item ${className || ''}`}
      {...props}
    />
  )
}

function ContextMenuSeparator({ className, ...props }: ComponentProps<typeof ContextMenuPrimitive.Separator>) {
  return (
    <ContextMenuPrimitive.Separator
      className={`context-menu-content__separator ${className || ''}`}
      {...props}
    />
  )
}

/**
 * Eine Gruppe von Einträgen. Sichtbar trennt sie der `ContextMenuSeparator`;
 * dieser Kasten sagt es zusätzlich den Screenreadern („Gruppe, 3 Einträge").
 * Ohne sichtbare Überschrift — die sagte nichts, was der Strich nicht schon
 * sagt, und machte aus zehn Zeilen vierzehn.
 */
const ContextMenuGroup = ContextMenuPrimitive.Group

const ContextMenuSub = ContextMenuPrimitive.Sub

/**
 * Die Zeile, die ein Unter-Menü aufklappt. Sie sieht aus wie jeder andere
 * Eintrag; den Unterschied macht das Zeichen rechts, das der Aufrufer als
 * `ContextMenuSubChevron` mitgibt — dieselbe Stelle, an der sonst Haken und
 * Kürzel stehen.
 */
function ContextMenuSubTrigger({ className, ...props }: ComponentProps<typeof ContextMenuPrimitive.SubTrigger>) {
  return (
    <ContextMenuPrimitive.SubTrigger
      className={`context-menu-content__item ${className || ''}`}
      {...props}
    />
  )
}

function ContextMenuSubContent({ className, ...props }: ComponentProps<typeof ContextMenuPrimitive.SubContent>) {
  return (
    <ContextMenuPrimitive.Portal>
      <ContextMenuPrimitive.SubContent
        className={`context-menu-content ${className || ''}`}
        {...props}
      />
    </ContextMenuPrimitive.Portal>
  )
}

/**
 * Der rechte Rand einer Zeile: Haken, Kürzel, Pfeil. Er steht als eigener
 * Kasten da, weil sonst jedes Kind sein eigenes `margin-left: auto` bräuchte —
 * und zwei davon teilten sich den freien Platz, statt beieinander zu bleiben.
 */
function ContextMenuItemTrailing({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={`context-menu-content__item-trailing ${className || ''}`}
      {...props}
    />
  )
}

function ContextMenuShortcut({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={`context-menu-content__shortcut ${className || ''}`}
      {...props}
    />
  )
}

export {
  ContextMenu,
  ContextMenuTrigger,
  ContextMenuContent,
  ContextMenuGroup,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubTrigger,
  ContextMenuSubContent,
  ContextMenuItemTrailing,
  ContextMenuSeparator,
  ContextMenuShortcut,
}
